var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRelaxLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.75128,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.497431
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7851 6.0392C10.3456 6.0392 9.98598 6.39879 9.98598 6.83828V8.0369H4.39243V6.83828C4.39243 6.39879 4.03683 6.0392 3.59335 6.0392C3.14986 6.0392 2.79427 6.39879 2.79427 6.83828V8.83598C2.79427 9.27548 3.15385 9.63506 3.59335 9.63506H10.7851C11.2246 9.63506 11.5841 9.27548 11.5841 8.83598V6.83828C11.5841 6.39879 11.2246 6.0392 10.7851 6.0392ZM9.58644 4.0415H4.79196C4.35247 4.0415 3.99289 4.40109 3.99289 4.84058V5.69959C4.45635 5.86341 4.79196 6.30689 4.79196 6.8223V7.63736H9.58644V6.8263C9.58644 6.30689 9.92206 5.8674 10.3855 5.70359V4.84058C10.3855 4.40109 10.0259 4.0415 9.58644 4.0415Z",
    fill: "#007FFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelaxLogo);
export default __webpack_public_path__ + "static/media/relaxLogo.de5ff3a537af8762e4ac4f6147cb5322.svg";
export { ForwardRef as ReactComponent };